import {
  addErrorHandler,
  type Application,
  registerApplication,
  start,
} from 'single-spa';
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from 'single-spa-layout';

import { showErrorPage } from './error-page';
import {
  setUpSpinnerMessageListener,
  showLoadingSpinner,
} from './loading-spinner';
import microfrontendLayout from './microfrontend-layout.html';

const reactRoutes = [
  'about',
  'accept-invitation',
  'checklists',
  'checklists-summary',
  'create-account',
  'dashboard',
  'diagnosis',
  'diagnostics',
  'diagnostics-report',
  'farms',
  'forgot-password',
  'gallery',
  'house-management',
  'icons-demo-page',
  'login',
  'medication',
  'opg-epg',
  'page-not-found',
  'password-reset',
  'photo-upload',
  'planned-diagnostics',
  'react',
  'request-access',
  'flock-result',
  'settings',
  'symptoms-report',
  'admin/programs/vaccination',
  'admin/programs/cocci',
  'admin/programs/other',
  'flock-card-daily',
  'general-flock-report',
  'quick-charts-react',
];

const reactRoutePatterns = [
  /\/flocks\/[^/]+\/reports$/, // Match /flocks/{id}/reports
  /\/flocks\/[^/]+\/scoring\/[^/]+\/voice$/, // Match /flocks/{flockId}/scoring/{reportId}/voice
];

setUpSpinnerMessageListener();
showLoadingSpinner();

const routes = constructRoutes(microfrontendLayout);

const applications = constructApplications({
  routes,
  loadApp: async ({ name }): Promise<Application> => await System.import(name),
});

const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach((app) => {
  const isReact = (location: Location): boolean =>
    location.pathname === '/' ||
    (!location.pathname.includes('farms-ember') &&
      reactRoutes.some((route) => location.pathname.includes(route))) ||
    reactRoutePatterns.some((pattern) => pattern.test(location.pathname));

  addErrorHandler((err) => {
    showErrorPage(err);
  });

  if (app.name === '@huvepharma/aviapp-react-common') {
    registerApplication({
      ...app,
      activeWhen: (location) => isReact(location),
    });
  } else if (app.name === '@huvepharma/aviapp-common') {
    registerApplication({
      ...app,
      activeWhen: (location) => !isReact(location),
    });
  }
});

layoutEngine.activate();
start({
  urlRerouteOnly: true,
});
